// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as IconCmp$PorterinFeature from "../../IconCmp.mjs";
import * as SpotEstimateVmV1$PorterinFeature from "../../../../view-model/SpotEstimateVmV1.mjs";
import * as SpotEstimateStore$PorterinFeature from "../../../../../../shared/core/constants/SpotEstimateStore.mjs";
import * as SecondaryButtonCmp$PorterinFeature from "../../../../../../shared/button/view/SecondaryButtonCmp.mjs";
import * as PermissionDeniedCmpModuleScss from "../styles/PermissionDeniedCmp.module.scss";

var styles = PermissionDeniedCmpModuleScss;

function PermissionDeniedCmp(Props) {
  var on_click = Props.on_click;
  return React.createElement("div", {
              className: styles.container
            }, React.createElement(IconCmp$PorterinFeature.make, {
                  image: SpotEstimateVmV1$PorterinFeature.location_denied_icon
                }), React.createElement("div", {
                  className: styles.text
                }, SpotEstimateStore$PorterinFeature.permission_denied_text), React.createElement("div", {
                  className: styles.subtext
                }, SpotEstimateStore$PorterinFeature.permission_denied_subtext), React.createElement(SecondaryButtonCmp$PorterinFeature.make, {
                  on_click: on_click,
                  children: SpotEstimateStore$PorterinFeature.permission_denied_action_button
                }));
}

var make = PermissionDeniedCmp;

export {
  styles ,
  make ,
}
/* styles Not a pure module */
